'use client';

import React, { type ReactElement, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { isDesktop } from 'react-device-detect';
import { selectIsTenant, useDomainStore } from '@/store/use-domain.store';
import Main from './components/main.component';

export default function HomeSearchFeatures(): ReactElement {
  const router = useRouter();
  const isTenant = useDomainStore(selectIsTenant);

  useEffect(() => {
    // Marketplace PLP redirect is Witro-only; tenants keep store-scoped /search.
    if (isDesktop && !isTenant) {
      router.replace('/search/products');
    }
  }, [isTenant, router]);

  return <Main />;
}
